import React from 'react'
import Banner from '../FirstPage/Banner'
import HomeSection from '../FirstPage/HomeSection'
import InnerPage from '../FirstPage/InnerPage'

const FirstBannerPage = () => {
  return (
    <>
      <Banner/>
      <HomeSection/>
      <InnerPage/>
    </>
  )
}

export default FirstBannerPage